import { adminRepositories } from "data/admin/repositories";

export const businessesRepo = {
  list(params) {
    return adminRepositories.businesses.list(params);
  },

  getById(id) {
    return adminRepositories.businesses.getById(id);
  },

  listByProvince(provinceId) {
    return adminRepositories.businesses.listByProvince(provinceId);
  },

  create(business) {
    return adminRepositories.businesses.create(business);
  },

  update(id, patch) {
    return adminRepositories.businesses.update(id, patch);
  },

  remove(id) {
    return adminRepositories.businesses.remove(id);
  },

  restore(id) {
    return adminRepositories.businesses.restore(id);
  },
};
